<!--  -->
<template>
  <div class="manage-container">
    <div class="manage-body">
      <div class="body-title">
        <span class="title">当前总预注册人数:</span>
        <span class="text">{{peopleNumber}}</span>
        <a-tooltip placement="topLeft" class="title-tips" overlayClassName="overlayStyle">
          <img src="~@/assets/images/promt.svg" alt class="title-icon" />

          <template #title>
            <span>当前总预注册人数 = 真实预注册数*增加倍数+增加基数+增长时间段内增长的数量</span>
          </template>
        </a-tooltip>
      </div>
      <div class="body-list">
        <div
          v-for="(item,index) in listItem"
          :class="index === 3 ? 'list-item2' : 'list-item'"
          :key="index"
        >
          <span class="item-title">-{{item.name}}</span>
          <span class="item-number">{{item.inner}}</span>
        </div>
      </div>
      <div class="body-form">
        <a-form :labelAlign="'left'" ref="manaForm">
          <div class="manaForm-item">
            <a-form-item label="增加倍数">
              <a-input
                v-model:value="manaFormState.multiple"
                class="item1"
                placeholder="请输入增加倍数"
                allowClear
              />
            </a-form-item>
            <a-form-item label="增加基数">
              <a-input
                v-model:value="manaFormState.base"
                class="item1"
                placeholder="请输入增加基数"
                allowClear
              />
            </a-form-item>
            <a-form-item label="增长时间段" placeholder="请输入增加时间段">
              <a-range-picker
                v-model:value="manaFormState.period"
                class="item1"
                show-time
                :placeholder="['开始时间','结束时间']"
                :disabledDate="disabledDate"
                @openChange="openChange"
              >
                <template #dateRender="{ current, today }">
                  <div class="ant-calendar-date">{{ current.date() }}</div>
                </template>
              </a-range-picker>
            </a-form-item>
            <a-form-item label="增长数量">
              <a-input
                v-model:value="manaFormState.number"
                class="item1"
                placeholder="请输入增长数量"
                allowClear
              />
            </a-form-item>
          </div>
        </a-form>
      </div>
    </div>
    <div class="manage-btn">
      <a-button type="primary" @click="onSubmit">确定修改</a-button>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, computed, watchEffect } from "vue";
// 导入的其他文件 例如：import moduleName from 'modulePath';
import { peopleCountsEdit, peopleCountsConfig } from "@/api/index.js";
import { message } from "ant-design-vue";
import moment from "moment";
import { useStore } from "vuex";
export default {
  //import所引入的组件注册
  setup() {
    const store = useStore();
    const state = reactive({
      peopleNumber: 0,
      listItem: [
        {
          name: "真实预注册人数:",
          inner: 0
        },
        {
          name: "增加倍数:",
          inner: "--"
        },
        {
          name: "增加基数:",
          inner: "--"
        },
        {
          name: "增加时间段:",
          inner: "--"
        },
        {
          name: "增长数量:",
          inner: "--"
        }
      ]
    });

    const manaFormState = reactive({
      multiple: null,
      base: null,
      period: [],
      number: null
    });
    let overlayStyle = {
      width: "520px !important"
    };

    // 事件
    const openChange = status => {
      // 强改time数据
      if (!status) {
        let date = new Date();
        if (moment(manaFormState.period[0]).unix() < moment(date).unix()) {
          manaFormState.period[0]._d = date;
        }
      }
    };
    const onSubmit = e => {
      if (
        !manaFormState.multiple &&
        !manaFormState.base &&
        manaFormState.period.length === 0 &&
        !manaFormState.number
      ) {
        message.error("请输入修改的内容！");
        return;
      }
      if (
        !manaFormState.number &&
        manaFormState.period &&
        manaFormState.period.length > 0
      ) {
        message.error("请输入对应的增长数量！");
        return;
      }
      if (manaFormState.number && manaFormState.period.length === 0) {
        message.error("请选择增长时间段!");
        return;
      }
      let params = {
        gameCode: gameCodeRef.value
      };
      if (manaFormState.multiple) {
        params.multiple = Number(manaFormState.multiple);
      }
      if (manaFormState.base) {
        params.baseNum = Number(manaFormState.base);
      }
      if (manaFormState.period.length > 0) {
        params.autoStartTime = Number.parseInt(
          moment(manaFormState.period[0]).unix()
        );
        params.autoEndTime = Number.parseInt(
          moment(manaFormState.period[1]).unix()
        );
      }
      if (manaFormState.number) {
        params.autoTargetNum = Number(manaFormState.number);
      }
      peopleCountsEdit(params).then(res => {
        if (res.status === 200) {
          message.success("修改成功！").then(() => {
            resetData();
            initMethod();
          });
        }
      });
    };
    const initMethod = () => {
      let params = {
        gameCode: gameCodeRef.value
      };
      peopleCountsConfig(params).then(res => {
        if (res.status === 200) {
          console.log(res, "resss");
          state.peopleNumber = res.data.totalUserCounts
          let data = res.data.peopleCount;
          const map = new Map();
          const arrChangeMap = arr =>
            new Map(arr.map((value, key) => [key, value]));
          let keyArr = [],
            valueArr = [],
            changeData = [];
          for (var { name: n, inner: i } of state.listItem) {
            map.set(n, i);
          }
          for (let [key, value] of map.entries()) {
            keyArr.push(key);
            valueArr.push(value);
          }
          valueArr = [
            res.data.realUserCounts,
            data.multiple ? data.multiple : "--",
            data.baseNum ? data.baseNum : "--",
            data.autoStartTime === 0 || !data.autoStartTime
              ? "--"
              : moment(data.autoStartTime && data.autoStartTime * 1000).format(
                  "YYYY/MM/DD HH:mm:ss"
                ) +
                " -- " +
                moment(data.autoEndTime && data.autoEndTime * 1000).format(
                  "YYYY/MM/DD HH:mm:ss"
                ),
            data.autoLastTargetNum ? data.autoLastTargetNum : "--"
          ];
          keyArr.forEach((item, index) => {
            let obj = {
              name: item,
              inner: valueArr[index]
            };
            changeData.push(obj);
          });
          state.listItem = changeData;
        }
      });
    };
    const resetData = () => {
      manaFormState.multiple = null;
      manaFormState.base = null;
      manaFormState.period = [];
      manaFormState.number = null;
    };
    const disabledDate = current => {
      return current && current < moment().subtract(1, "days");
    };
    let gameCodeRef = computed(() => store.state.settings.currentGamgeCode);
    // let loadingRef = computed(() => store.state.settings.loading);
    // let multipleRef = computed(() => manaFormState.multiple);
    // let baseRef = computed(() => manaFormState.base);
    // let numberRef = computed(() => manaFormState.number);
    // watch(
    //   [gameCodeRef, multipleRef, baseRef, numberRef, loadingRef],
    //   (
    //     [gameCode, multiple, base, number, loading],
    //     [preGameCode, preMultiple, preBase, preNumber, preLoading]
    //   ) => {
    //     if (gameCode) {
    //       initMethod();
    //     }
    //     if (loading) {
    //       console.log("dsl;dl;sdls;dl;slds;");
    //       resetData();
    //     }
    //     // 实时把非数字的输入过滤掉
    //     manaFormState.multiple =
    //       multiple && multiple.match(/\d/gi)
    //         ? multiple.match(/\d/gi).join("")
    //         : "";
    //     manaFormState.base =
    //       base && base.match(/\d/gi) ? base.match(/\d/gi).join("") : "";
    //     manaFormState.number =
    //       number && number.match(/\d/gi) ? number.match(/\d/gi).join("") : "";

    //   }
    // );
    watchEffect(() => {
      if (store.state.settings.loading) {
        resetData();
      }
      if (store.state.settings.currentGamgeCode) {
        initMethod();
      }
      // 实时把非数字的输入过滤掉;
      manaFormState.multiple =
        manaFormState.multiple && manaFormState.multiple.match(/\d/gi)
          ? manaFormState.multiple.match(/\d/gi).join("")
          : "";
      manaFormState.base =
        manaFormState.base && manaFormState.base.match(/\d/gi)
          ? manaFormState.base.match(/\d/gi).join("")
          : "";
      manaFormState.number =
        manaFormState.number && manaFormState.number.match(/\d/gi)
          ? manaFormState.number.match(/\d/gi).join("")
          : "";
      if (!manaFormState.multiple) {
        manaFormState.multiple = "";
        return false;
      }
      if (!manaFormState.base) {
        manaFormState.base = "";
        return false;
      }
      if (!manaFormState.number) {
        manaFormState.number = "";
        return false;
      }
    });
    onMounted(() => {});
    return {
      ...toRefs(state),
      manaFormState,
      onSubmit,
      disabledDate,
      openChange,
      overlayStyle
    };
  },
  components: {}
};
</script>
<style lang="less">
.overlayStyle .ant-tooltip-inner {
  width: 520px;
}
.manaForm-item .ant-form-item:not(:first-child) {
  margin-left: 30px;
}
</style>
<style lang='less' scoped>
@import "./index.less";
</style>